import React from 'react';
import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

function NavComponent() {

    const redirigirContacto = () => {
        window.open("https://www.grupobrame.com/contactus", "_blank", "noopener,noreferrer");
    };

    return (

        <header className="bg-gray-100">
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
                <div className="flex items-center gap-x-12">
                    <a href="#" className="-m-1.5 p-1.5">
                        <span className="sr-only">Your Company</span>
                        <img
                            alt=""
                            src={require("../img/logo-brame.png")}
                            className="h-18 w-auto"
                        />
                    </a>
                </div>
                <div className=" lg:flex">
                    <div>
                        <button
                            onClick={redirigirContacto}
                            className="flex w-full justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-orange-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                        >
                            Contactanos
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default NavComponent;